// extracted by mini-css-extract-plugin
export var contentBody = "_aa-9";
export var headerImage = "_aa-2";
export var imageButton = "_aa-7";
export var imageButtonIcon = "_aa-8";
export var imageHeader = "_aa-4";
export var imageHeaderText = "_aa-5";
export var imageOverlay = "_aa-3";
export var imageTitle = "_aa-6";
export var imageWrapper = "_aa-1";
export var taskList = "_aa-a";
export var widget = "_aa-0";